import { Container } from "@bsf/force-ui";
import HeaderLine from '@components/HeaderLine'
import NavMenu from '@components/NavMenu'
import React from 'react'
import Widgets from './Widgets'
import TemplateSection from './TemplateSection'
import QuickAccess from './QuickAccess'
import WelcomeContainer from './WelcomeContainer'
import ExtendWebsite from './ExtendWebsite'
import VideoTutorials from "./VideoTutorials";
import QuickSettings from './QuickSettings';

const Dashboard = () => {
    const width_class = !uaelSettingsData.hide_settings ? 'uael-65-width' : 'w-full';

    return (
        <>
            <NavMenu />
            <div className="">
                <HeaderLine />
                <Container
                    align="stretch"
                    className="p-6 flex flex-col lg:flex-row box-border"
                    containerType="flex"
                    direction="row"
                    gap="sm"
                    justify="start"
                    style={{
                        width: "100%",
                    }}
                >
                    <Container.Item
                        className={`p-2 ${width_class}`}
                        alignSelf="auto"
                        order="none"
                        shrink={0}
                    >
                        {!uaelSettingsData.hide_settings && (
                            <WelcomeContainer />
                        )}
                        <div className=''>
                            <QuickSettings />
                        </div>
                        {/* <Widgets /> */}
                        {!uaelSettingsData.hide_settings && (
                            <VideoTutorials />
                        )}
                         <ExtendWebsite />
                    </Container.Item>
                    {!uaelSettingsData.hide_settings && (
                        <Container.Item
                            className="p-2 w-full uael-35-width"
                            shrink={1}
                        >
                                  <TemplateSection />
                            <div className="pt-5">
                              <QuickAccess />
                            </div>
                        </Container.Item>
                    )}

                </Container>
            </div>
        </>
    )
}

export default Dashboard
